<script lang="ts">
  import Level from './Level.svelte'
  import Tooltip from '../tooltip/Tooltip.svelte'
  import ProfileLevelDetails from './ProfileLevelDetails.svelte'
  import { sparkling } from '$lib/actions/sparkling'
  import { xpInfo } from '$lib/utils/profile'

  interface Props {
    points: number
    multiplier: number
  }

  let { points, multiplier }: Props = $props()

  let { tier } = $derived(xpInfo(points))
</script>

<div class="level glob-has-tooltip">
  <div class="number" use:sparkling={{ tier }}>
    <Level {multiplier} xp={points} />
  </div>

  <Tooltip style="status">
    <div class="tooltip-content">
      <ProfileLevelDetails {points} {multiplier} />
    </div>
  </Tooltip>
</div>

<style lang="postcss">
  .level {
    display: flex;
    position: relative;
    align-items: center;
    gap: 0.5rem;
    padding: 2% 0 2% 2%;
    height: 100%;
    line-height: 100%;
  }

  .number {
    container-type: size;
    aspect-ratio: 1;
    height: 100%;
  }

  .tooltip-content {
    padding-block: 0.125rem 0.25rem;
    width: 10rem;
  }
</style>
